import React, { useEffect, useState } from "react";
import { ProgressBar, Button } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { useTranslation } from "react-i18next";
import {
  checkOnboardingStatus,
  getEmployeeOnboardingSteps,
} from "../../../services/onBoardingServices";
import iconMap from "../../../config/iconConfig";
import { useNavigate } from "react-router-dom";
import { companyID } from "../../../auth";
import { updateOnboardingStatus } from "../../../utils/updateOnboardingStatus";
import { encrypt } from "../../../utils/crypto";

const Onboarding = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [OnboardingSteps, setOnboardingSteps] = useState([]);
  const [progress, setProgress] = useState(0);

  const companyName = localStorage.getItem("companyName");
  const company_id = companyID();
  const loginEmployee = localStorage.getItem("employeeID");
  const encryptedEmployeeID = encrypt(loginEmployee);

  const employeeOnboardingStatus = async () => {
    try {
      const result = await checkOnboardingStatus(loginEmployee, company_id);
      if (result?.success === true && result?.alreadyUpToDate === false) {
        updateOnboardingStatus("COMPLETED");
        window.location.reload();
      } else if (result?.success === true && result?.alreadyUpToDate === true) {
        updateOnboardingStatus("COMPLETED");
      } else {
        updateOnboardingStatus("PENDING");
      }
    } catch (error) {
      console.error("Error fetching onboarding status:", error);
    }
  };
  useEffect(() => {
    if (loginEmployee) {
      employeeOnboardingStatus();
    }
  }, [loginEmployee]);

  useEffect(() => {
    const fetchAndCalculateProgress = async () => {
      if (loginEmployee) {
        try {
          const result = await getEmployeeOnboardingSteps(loginEmployee);
          if (result?.success === true) {
            const steps = result?.OnboardingSteps || [];
            setOnboardingSteps(steps);

            const completedSteps = steps.filter(
              (step) => step.status === "COMPLETED"
            ).length;
            const totalSteps = steps.length;
            const calculatedProgress = Math.round(
              (completedSteps / totalSteps) * 100
            );
            setProgress(calculatedProgress);
          }
        } catch (error) {
          console.error(error);
        }
      }
    };

    fetchAndCalculateProgress();
  }, [loginEmployee]);

  return (
    <div className="page-wrapper">
      {/* Page Content */}
      <div className="content container-fluid">
        {/* Progress Header */}
        <div className="mb-4">
          <Breadcrumbs
            maintitle={t("Onboarding")}
            title={t("Dashboard")}
            subtitle={t("Onboarding")}
          />
          <h6 className="fw-semibold text-muted mb-1">Onboarding Progress</h6>

          <ProgressBar
            now={progress}
            style={{ height: "6px" }}
            variant="primary"
          />
          <div className="text-muted small mt-1">{progress}%</div>
        </div>

        <div className="mb-4">
          <h3 className="fw-bold">Welcome to {companyName}</h3>
          <p className="text-muted mb-0">
            Let's get you set up. Here's what we need to do:
          </p>
        </div>

        <div className="d-flex flex-column gap-4 mb-4">
          {OnboardingSteps.map((step, idx) => {
            const IconComponent = iconMap[step.stepIcon];
            const isButtonVisible =
              step.stepOrder === 1 ||
              (idx > 0 && OnboardingSteps[idx - 1].status === "COMPLETED");
            const color =
              step.status === "PENDING"
                ? "warning"
                : step.status === "IN_PROGRESS"
                ? "info"
                : "success";
            return (
              <div key={idx}>
                <div className="d-flex gap-3 justify-content-between align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center bg-secondary text-white"
                      style={{
                        width: "40px",
                        height: "40px",
                      }}
                    >
                      {IconComponent ? (
                        <IconComponent size={20} />
                      ) : (
                        <div
                          className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center"
                          style={{
                            width: 40,
                            height: 30,
                            fontSize: "1.5rem",
                          }}
                        >
                          {step.stepName[0]}
                        </div>
                      )}
                    </div>
                    <div className="fw-semibold">{step.stepName}</div>
                  </div>
                  <span
                    className={`small mt-1 badge badge-${color} d-inline-flex align-items-center`}
                  >
                    {step.status}
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center gap-2 mt-1">
                  <div className="text-muted small">{step.stepDesc}</div>
                  {isButtonVisible && (
                    <Button
                      variant="btn-link"
                      className="text-primary fw-semibold bor-rad-50 small d-inline-flex align-items-center"
                      style={{ whiteSpace: "nowrap" }}
                      onClick={() =>
                        navigate(
                          `../onboarding-${step.stepKey}/${encryptedEmployeeID}`,
                          {
                            state: { step: step, action: "upload" },
                          }
                        )
                      }
                    >
                      {step.status === "COMPLETED" ? "View" : "Continue"}
                      <BsArrowRight className="ms-1" />
                    </Button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
